// extracted by mini-css-extract-plugin
module.exports = {"action":"ClientUnitPriceTable__action--3Io-A","create":"ClientUnitPriceTable__create--3rwMp"};